/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type WeightTransactionReversalInput = {
    readonly transactionId: string;
    readonly reason?: string | null;
    readonly timestamp: any;
    readonly clientMutationId?: string | null;
};
export type WeightTransactionReversalMutationVariables = {
    readonly input: WeightTransactionReversalInput;
};
export type WeightTransactionReversalMutationResponse = {
    readonly weightTransactionReversal: ({
        readonly clientMutationId: string | null;
        readonly weightTransaction: {
            readonly id: string;
        };
    }) | null;
};
export type WeightTransactionReversalMutation = {
    readonly response: WeightTransactionReversalMutationResponse;
    readonly variables: WeightTransactionReversalMutationVariables;
};



/*
mutation WeightTransactionReversalMutation(
  $input: WeightTransactionReversalInput!
) {
  weightTransactionReversal(input: $input) {
    clientMutationId
    weightTransaction {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "WeightTransactionReversalInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "weightTransactionReversal",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "WeightTransactionReversalInput!"
      }
    ],
    "concreteType": "WeightTransactionReversalPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "weightTransaction",
        "storageKey": null,
        "args": null,
        "concreteType": "WeightTransaction",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "WeightTransactionReversalMutation",
  "id": null,
  "text": "mutation WeightTransactionReversalMutation(\n  $input: WeightTransactionReversalInput!\n) {\n  weightTransactionReversal(input: $input) {\n    clientMutationId\n    weightTransaction {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "WeightTransactionReversalMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "WeightTransactionReversalMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
(node as any).hash = 'ed671403ce1cd1300cda8685dbde783c';
export default node;
